function hashCode (str) {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  return hash
}

function intToRGB (i) {
  const c = (i & 0x00FFFFFF)
    .toString(16)
    .toUpperCase()

  return '00000'.substring(0, 6 - c.length) + c
}

// https://stackoverflow.com/questions/3426404/create-a-hexadecimal-colour-based-on-a-string-with-javascript
export const stringToHexColor = value => `#${intToRGB(hashCode(value))}`

export const downloadFile = fileUrl => {
  const a = document.createElement('a')
  a.href = fileUrl
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

export function getDepth (arr, fieldName) {
  let maxDepth = 0
  if (arr.length > 0) {
    arr.forEach(element => {
      const dpth = getDepth(element[fieldName], fieldName)
      if (dpth > maxDepth) {
        maxDepth = dpth
      }
    })
  }
  return maxDepth + 1
}

export function maxCountOfChildren (arr, fieldName) {
  let maxChildren = arr.length
  if (maxChildren > 0) {
    arr.forEach(element => {
      const childrenAmount = maxCountOfChildren(element[fieldName], fieldName)
      if (childrenAmount > maxChildren) {
        maxChildren = childrenAmount
      }
    })
  }
  return maxChildren
}
